<template>
    <nav>
        <label for="search" class="sr-only">Search</label>
        <span class="search-container">
            <input id="search" type="text"
                :placeholder="$t('labels.search_bar_placeholder')"
                ref="searchBox"
                :value="searchQuery"
                v-on:change="searchQueryChanged"
                v-on:keyup.enter="searchQueryChanged" />
        </span>
        <div id="buttons">
            <router-link :to="{name: 'recipients'}" class="nav-link">{{ $t('menu.recipients') }}</router-link>
            <router-link :to="{name: 'medals'}" class="nav-link">{{ $t('menu.medals') }}</router-link>
            <router-link :to="{name: 'themes'}" class="nav-link">{{ $t('menu.themes') }}</router-link>
        </div>

        <!-- 
            mobile - 
            hide links to medals, recipients, themes
         -->
    </nav>
</template>

<script>
import StyledButton from "@/components/StyledButton"

export default {
    components: {
        StyledButton,
    },
    data: function() {
        return {
            searchQuery: null
        }
    },
    methods: {
        searchQueryChanged: function(event) {
            event.preventDefault()
            event.stopPropagation()
            this.search(event.target.value);
        },
        search: function(query) {
            let route = Object.assign({}, this.$route.query);

            if (query !== '') {
                route['q'] = encodeURI(query)
            } else {
                delete route['q']
            }

            this.$router.replace({
                query: Object.assign({}, route)
            });
        },
        searchSubmit: (event) => {
            event.preventDefault();
        }
    },
    async mounted() {
        if ("q" in this.$route.query) {
            this.searchQuery = decodeURI(this.$route.query.q)
        }
    }
}
</script>

<style scoped lang="scss">

nav {
    background-color: #1f272e;
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    z-index: 1;
    padding: 10px 100px;

    position: -webkit-sticky;
    position: sticky;
    top: -20px;
}

input {
    width: 310px;
    height: 35px;
    color: #92b2cf;
    background-color: transparent;
    border-style: none;
    border-bottom: solid 1px #92b2cf;
    font-size: 20px;
    margin-right: 20px;
    padding-right: 45px;
    box-sizing: border-box;
}

input::-webkit-input-placeholder,
input::placeholder {
    color: #92b2cf;
}

html[lang="fr"] {
    input {
        font-size: 18px;
    }
}

.search-container:after {
    content: url('../assets/icons/icon-search.svg');
    width: 25px;
    height: 25px;
    margin-left: -55px;
}

#buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 400px;
}

.nav-link {
    color: #ffffff;
    font-size: 14px;
    font-family: 'FuturaBold';
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 2px;
    font-weight: bold;
    position: relative;
    transition: color 250ms ease;
    margin-right: 10px;
}

.nav-link:hover,
.nav-link.router-link-active {
    color: #00b74f;
}

.nav-link.router-link-active:after {
    content: "";
    border-bottom: solid 1px #00b74f;
    width: 100%;
    height: 4px;
    display: block;
    position: absolute;
    top: 20px;
}

@media screen and (max-width: 920px) {
    #buttons {
        display: none;
    }
    nav {
        height: 60px;
        padding: 10px 30px;

        .search-container {
            padding-top: 15px;
        }
    }
}
@media screen and (max-width: 700px) {
    nav input {
        font-size: 18px;
        margin-top: 10px;
    }
}

@media screen and (max-width: 500px) {
    nav {
        flex-direction: column-reverse;
        align-items: flex-start;
        flex-wrap: nowrap;
    }

    nav input {
        margin-top: 25px;
    }
}

@media screen and (max-width: 400px) {
   nav {
       padding-left: 5px;
   }
   nav input {
        width: 100%;
        min-width: 260px;
        margin-right: 20px;
   }
        
    html[lang="fr"] {
        input {
            font-size: 14px;
        }
    }

}


</style>